export const MENU_TEXT_EN =
{
    home: 'HOME',
    service: 'SERVICES',
    about: 'ABOUT US',
    BeautyBlog: 'BEAUTY BLOG',
    gallery: 'GALLERY', 
    testimonials: 'REVIEW & TESTIMONIALS', 
    newsAndPromotion: 'NEWS & PROMOTION',
    location: 'LOCATION',
    branch: 'BRANCHES',
    tk_branch : 'Take Care Branch',
    blog : 'BLOG',
}
export const MENU_TEXT_TH =
{
    home: 'หน้าหลัก',
    service: 'ข้อมูลบริการ',
    about: 'ประวัติความเป็นมา',
    BeautyBlog: 'BEAUTY BLOG',
    testimonials: 'REVIEW & TESTIMONIALS',
    gallery: 'รูปภาพ',
    newsAndPromotion: 'ข่าวสาร & โปรโมชั่น',
    location: 'ติดต่อเรา',
    branch: 'สาขา',
    tk_branch : 'สาขาทั้งหมดของ Take Care',
    blog : 'BLOG',
}


// WEBPACK FOOTER //
// ./src/app/mokup/menu.ts